import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import * as ThemeActions from 'redux/actions/ThemeActions';
import {BiSun, BiMoon} from "react-icons/bi";

export default () => {
    const dispatch = useDispatch()

    const ThemeState = useSelector((state) => state.Theme.theme);

    const switchTheme = () => {
        dispatch(
            ThemeActions.handleChangeTheme({
                theme: ThemeState === 'dark' ? 'light' : 'dark'
            })
        )
        if (window.Android) {
            window.Android.onThemeChanged(ThemeState === 'dark' ? 'light' : 'dark');
        }
    }

    return <div className={'w-auto'}>
        <input type={'checkbox'}
               className={'theme-checkbox'}
               id={'theme-checkbox'}
               onChange={switchTheme}
               checked={ThemeState === 'dark'}
        />
        <label htmlFor={'theme-checkbox'} className={'theme-checkbox-label'}>
            <BiMoon color={'#b0b5bb'} size={'1.14rem'}/>
            <BiSun color={'#f1c40f'} size={'1.14rem'}/>
            <span className="ball">
                {
                    ThemeState === 'dark'
                        ? <BiMoon color={'#ffffff'} size={'1.14rem'}/>
                        : <BiSun color={'#f1c40f'} size={'1.14rem'}/>
                }
            </span>
        </label>
    </div>
}
